import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { HelpersService } from '../../../../../services';
import { PartnerService } from '../../../../../services/partner.service';
import { SalesService } from '../../../../../services/sales.service';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'app-add-edit-bikesale-item',
  templateUrl: './add-edit-bikesale-item.component.html',
  styleUrls: ['./add-edit-bikesale-item.component.scss'],
})
export class AddEditBikesaleItemComponent implements OnInit {
  @Input() bikeSaleItem;
  @Output() close = new EventEmitter();

  public partnerId: string = '';
  public partner: any = {};

  public loadingTemplates: boolean = false;
  public loadingTags: boolean = false;
  public loadingTypes: boolean = false;
  public saving: boolean = false;
  public deleting: boolean = false;

  public tag: string = '';
  public type: string = '';
  public productTypes: SelectItem[] = [];
  public productTags: SelectItem[] = [];
  public messageTemplates: SelectItem[] = [];
  public messageTemplatesFull: any = [];

  public selectedTemplate: number = -1;
  public selectedProductType: any = {};
  public selectedProductTypes: any[] = [];
  public selectedProductTags: any[] = [];
  public selectedProductTag: any = {};
  public selectedTags: string = '';
  public selectedTypes: string = '';
  public disabled: boolean = true;
  public bikeSaleItemID: number = 0;

  constructor(
    private helpersService: HelpersService,
    private partnerService: PartnerService,
    private saleService: SalesService,
  ) {
    this.partnerId = this.helpersService.getPartnerId();
    this.partner = this.helpersService.getPartnerData();
  }

  ngOnInit() {
    this.selectedTemplate = -1;
    this.selectedProductType = {};
    this.selectedProductTag = {};
    this.getMessageTemplates();
    this.getProductTypes();
    this.getProductTags();

    this.bikeSaleItemID = this.bikeSaleItem.ID;
  }

  ngOnChanges() {
    // console.log('www');
    // this.validate();
  }

  addTag() {
    //if (this.productTags.length > 0) {
    //  if (this.selectedProductTag !== {})
    //    this.tag = this.productTags[this.selectedProductTag].label
    //}

    if (this.tag !== '') {
      if (this.bikeSaleItem.ProductTags.findIndex((x) => x === this.tag) == -1)
        this.bikeSaleItem.ProductTags.push(this.tag);
    } else {
      //this.tag = "";
      //console.log(this.selectedProductTags);
      this.bikeSaleItem.ProductTags = [];
      for (var i = 0; i < this.selectedProductTags.length; i++) {
        this.bikeSaleItem.ProductTags.push(
          this.productTags[this.selectedProductTags[i]].label,
        );
      }
    }
  }

  addType() {
    //if (this.productTypes.length > 0) {
    //  if (this.selectedProductType !== {})
    //    this.type = this.productTypes[this.selectedProductType].label
    //}
    this.bikeSaleItem.ProductTypes = [];
    if (this.type !== '') {
      if (
        this.bikeSaleItem.ProductTypes.findIndex((x) => x === this.type) == -1
      )
        this.bikeSaleItem.ProductTypes.push(this.type);
      //this.type = "";
      ////this.selectedProductType = {};
      //console.log(this.selectedProductTypes);
    } else {
      //this.bikeSaleItem.ProductTypes = [];
      //this.bikeSaleItem.ProductTypes.push(this.productTypes[this.selectedProductType].label);
      //this.bikeSaleItem.ProductTypes = this.selectedProductType;
      for (var i = 0; i < this.selectedProductTypes.length; i++) {
        this.bikeSaleItem.ProductTypes.push(
          this.productTypes[this.selectedProductTypes[i]].label,
        );
      }
    }
  }

  deleteTag(id) {
    var a = this.bikeSaleItem.ProductTags.findIndex((x) => x === id);
    this.bikeSaleItem.ProductTags.splice(a, 1);
  }

  deleteType(id) {
    var a = this.bikeSaleItem.ProductTypes.findIndex((x) => x === id);
    this.bikeSaleItem.ProductTypes.splice(a, 1);
  }

  getMessageTemplates() {
    this.loadingTemplates = true;
    this.partnerService
      .getMessageTemplates(this.partnerId)
      .subscribe((templates) => {
        templates.forEach((template) => {
          template.Order = 100;
        });

        for (var i = 0; i < templates.length; i++) {
          if (
            templates[i].Description.toLocaleUpperCase() == 'BIKE SALE' &&
            templates[i].EventTag.toLocaleUpperCase() !== 'BIKE.SALE.FOLLOWUP'
          )
            this.messageTemplates.push({
              label: templates[i].EventTag,
              value: templates[i].ID,
            });
        }

        for (var i = 0; i < templates.length; i++) {
          if (templates[i].ID === this.bikeSaleItem.LinkedMessageTemplateID)
            this.selectedTemplate = templates[i].ID;
        }

        this.messageTemplatesFull = templates;

        this.loadingTemplates = false;
      });
  }

  getProductTypes() {
    this.loadingTypes = true;
    this.saleService.getProductTypes(this.partnerId).subscribe((types) => {
      for (var i = 0; i < types.length; i++) {
        this.productTypes.push({ label: types[i], value: i });
      }

      for (var i = 0; i < this.bikeSaleItem.ProductTypes.length; i++) {
        for (var x = 0; x < this.productTypes.length; x++) {
          if (
            this.bikeSaleItem.ProductTypes[i].toUpperCase() ==
            this.productTypes[x].label.toUpperCase()
          ) {
            this.selectedTypes =
              this.selectedTypes + this.productTypes[x].label + ', ';
            this.selectedProductType = this.productTypes[x].value;
            this.selectedProductTypes.push(x);
          }
        }
      }

      this.loadingTypes = false;
      this.selectedTypes = this.selectedTypes.substring(
        0,
        this.selectedTypes.length - 2,
      );
    });
  }

  getProductTags() {
    this.loadingTags = true;
    this.saleService.getProductTags(this.partnerId).subscribe((result) => {
      for (var i = 0; i < result.length; i++) {
        this.productTags.push({ label: result[i], value: i });
      }

      for (var i = 0; i < this.bikeSaleItem.ProductTags.length; i++) {
        for (var x = 0; x < this.productTags.length; x++) {
          if (
            this.bikeSaleItem.ProductTags[i].toUpperCase() ==
            this.productTags[x].label.toUpperCase()
          ) {
            this.selectedTags =
              this.selectedTags + this.productTags[x].label + ', ';
            this.selectedProductTags.push(x);
          }
        }
      }

      this.loadingTags = false;
      this.selectedTags = this.selectedTags.substring(
        0,
        this.selectedTags.length - 2,
      );
      //console.log(this.productTags);
      //console.log(this.selectedProductTags);
    });
  }

  saveBikeSale() {
    this.saving = true;
    this.bikeSaleItem.LinkedMessageTemplateID = this.selectedTemplate;

    if (this.bikeSaleItem.ProductTags == undefined)
      this.bikeSaleItem.ProductTags = [];

    if (this.bikeSaleItem.ProductTypes == undefined)
      this.bikeSaleItem.ProductTypes = [];

    //console.log(this.bikeSaleItem);

    this.saleService
      .createSaleCommunnicationTemplate(
        this.partnerId,
        JSON.stringify(this.bikeSaleItem),
      )
      .subscribe((result) => {
        this.saving = false;
        this.close.emit();
      });
  }

  deleteBikeSale() {
    this.deleting = true;
    this.bikeSaleItem.ID = -this.bikeSaleItem.ID;
    this.saleService
      .createSaleCommunnicationTemplate(
        this.partnerId,
        JSON.stringify(this.bikeSaleItem),
      )
      .subscribe((result) => {
        this.deleting = false;
        this.close.emit();
      });
  }

  validate() {
    if (this.selectedTemplate != -1)
      this.bikeSaleItem.LinkedMessageTemplateID = this.selectedTemplate;

    if (this.bikeSaleItem.LinkedMessageTemplateID > 0)
      if (this.bikeSaleItem.Type != '')
        if (
          this.bikeSaleItem.ProductTypes.length > 0 ||
          this.bikeSaleItem.ProductTags.length > 0
        ) {
          this.disabled = false;
          return false;
        }
    return true;
  }
}
